<template>
  <div>
    <router-view :key="moduleKey" v-if="moduleIsReady"/>
    <div v-else>Loading users...</div>
  </div>
</template>

<script>
// import { FETCH_USERS } from './store';

export default {
  name: 'UserAccountsModule',

  created() {
    // this.bootstrap();
  },

  computed: {
    moduleIsReady() {
      return true; // !!this.users; // true; //
    },

    moduleKey() {
      return 'users';
    },
  },

  methods: {
    // async bootstrap() {
    //   try {
    //     await this.$store.dispatch(FETCH_USERS);
    //   } catch (err) {
    //     console.error('user accounts bootstrap err', err);
    //     if (err.message === 'Network Error') {
    //       this.$router.push({ name: 'NotFound' });
    //     } else {
    //       this.$router.push({ name: 'UnAuthorized' });
    //     }
    //   }
    // },
  },
};
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
